import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { projetos } from '../../mocks/projetos';

export default function ProjetosPage() {
  const [filtro, setFiltro] = useState<string>('Todos');

  const filtros = ['Todos', 'Oportunidade', 'Único', 'Investimento'];

  const projetosFiltrados =
    filtro === 'Todos' ? projetos : projetos.filter((p) => p.status === filtro);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-20">
        <section className="bg-white py-24">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="text-center mb-12">
              <h1 className="text-6xl font-bold text-black mb-6">Nosso Projeto</h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Conheça o projeto de construção residencial da Bravia Group na Flórida. Com acompanhamento transparente e foco em qualidade.
              </p>
            </div>

            <div className="flex justify-center mb-12">
              <div className="inline-flex bg-gray-100 rounded-full p-1">
                {filtros.map((f) => (
                  <button
                    key={f}
                    onClick={() => setFiltro(f)}
                    className={`px-6 py-3 rounded-full font-medium text-sm transition-all whitespace-nowrap cursor-pointer ${
                      filtro === f
                        ? 'bg-black text-white'
                        : 'text-gray-600 hover:text-black'
                    }`}
                  >
                    {f}
                  </button>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
              {projetosFiltrados.map((projeto) => (
                <div
                  key={projeto.id}
                  className="bg-white border border-gray-200 rounded-3xl overflow-hidden hover:shadow-2xl transition-all duration-300 group cursor-pointer"
                >
                  <div className="relative h-64 overflow-hidden">
                    <img
                      src={projeto.imagem}
                      alt={projeto.nome}
                      className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-4 left-4">
                      <span
                        className={`px-4 py-2 rounded-full text-sm font-medium backdrop-blur-md ${
                          projeto.status === 'Oportunidade'
                            ? 'bg-blue-500/80 text-white'
                            : projeto.status === 'Único'
                            ? 'bg-green-500/80 text-white'
                            : 'bg-gold-500/80 text-gray-900'
                        }`}
                      >
                        {projeto.status}
                      </span>
                    </div>
                  </div>

                  <div className="p-8">
                    <h3 className="text-2xl font-bold text-black mb-2">{projeto.nome}</h3>
                    <div className="flex items-center text-gray-600 mb-4">
                      <i className="ri-map-pin-line mr-2"></i>
                      <span>{projeto.localizacao}</span>
                    </div>
                    <p className="text-gray-700 leading-relaxed mb-6">{projeto.descricao}</p>

                    <div className="border-t border-gray-100 pt-6 mb-6 space-y-3">
                      <div className="flex items-center text-gray-700">
                        <i className="ri-time-line mr-2"></i>
                        <span className="font-medium">{projeto.prazo}</span>
                      </div>
                      <div className="flex items-center text-gray-700">
                        <i className="ri-money-dollar-circle-line mr-2"></i>
                        <span className="font-medium">A partir de {projeto.investimentoMinimo}</span>
                      </div>
                    </div>

                    <Link
                      to={`/projetos/${projeto.id}`}
                      className="block w-full py-3 border-2 border-black text-black text-center font-semibold rounded-lg hover:bg-black hover:text-white transition-all whitespace-nowrap"
                    >
                      Ver detalhes completos
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
